import { f as i } from "./addOns-5IZhcbHD.js";
const r = {
  id: "FloridaPick5",
  name: "Pick 5",
  style: {
    colorPrimary: "#4296b4",
    fireball: i
  }
};
export {
  r as default
};
